<div class="content-block" id="novaufa">
    <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
        [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
    </dx-load-panel>

    <div class="zaglavlje">
        <p class="naslovStr">
            <dx-button class="btnNatrag" text="natrag" type="default" icon="back" (onClick)="odustaniUFA()"></dx-button>
            <i class="dx-icon-doc customIcon"></i>{{ naslovStranice }}
            <span *ngIf="brojUFE" style="font-weight: bold;">{{ brojUFE }}/{{ godinaUFE }}</span>
            <span *ngIf="storniranBoolean" style="font-weight: bold; color: red">{{ status }}</span>
        </p>
    </div>

    <!------------ NOVA UFA --------------->
    <!-- <div class=" content-block formaitroskovi"> -->
    <div class="forma">
        <dx-form class="content-block" id="forma" [formData]="ulaznafaktura" colCount="2" colSpan="2"
            labelLocation="left" #formaGlavna validationGroup="validacijaPrimka"
            (onContentReady)="onContentReady($event)" (onEditorEnterKey)="onEditorEnterKey($event)">
            <dxi-item itemType="group">
                <dxi-item *ngIf="partneri" dataField="partner_pa_id" [label]="{text: 'Partner'}"
                    editorType="dxSelectBox"
                    [editorOptions]="{ value: partner, dataSource: partneri, displayExpr: displayPartner, valueExpr: 'pa_id', searchEnabled: 'true',                                   
                                        showClearButton: 'true', onValueChanged: partnerChange, width: '400px', readOnly: samoPregled || statusUFA === 'n', virtualScrooling: true }">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="uf_brojracuna" [label]="{text: 'Broj računa'}" editorType="dxTextBox"
                    [editorOptions]="{width: '150px', readOnly: (samoPregled || statusUFA === 'z') && omoguciZavrseneIzmjene == false}">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="uf_datum" [label]="{text: 'Datum računa'}" editorType="dxDateBox"
                    [editorOptions]="{ value: datumRacuna, type:'date', width: '150px', onValueChanged: datumRacunaChange, displayFormat:'dd.MM.yyyy.', readOnly: samoPregled || statusUFA === 'z'}">
                </dxi-item>
                <dxi-item dataField="uf_valuta" [label]="{text: 'Datum valute'}" editorType="dxDateBox"
                    [editorOptions]="{ value: datumValute, type:'date', width: '150px', onValueChanged: datumValuteChange, displayFormat:'dd.MM.yyyy.', readOnly: samoPregled || statusUFA === 'z'}">
                </dxi-item>
                <dxi-item dataField="uf_napomena" [label]="{text: 'Napomena'}" editorType="dxTextArea"
                    [editorOptions]="{ stylingMode: 'outlined',  width: '400px', readOnly: samoPregled || statusUFA === 'z' }">
                </dxi-item>
                <dxi-item dataField="uf_brojnarudzbe" [label]="{text: 'Broj narudžbe'}" editorType="dxTextBox"
                    [editorOptions]="{width: '150px', readOnly: samoPregled || statusUFA === 'z'}">
                </dxi-item>
                <dxi-item *ngIf="poslovnicePrijema" dataField="poslovnica_po_id" [label]="{text: 'Poslovnica prijema'}"
                    editorType="dxSelectBox"
                    [editorOptions]="{ value: poslovnicaPrijema, dataSource: poslovnicePrijema, displayExpr: displayPoslovnicaPrijema, valueExpr: 'idposlovnica', searchEnabled: 'true',
                                        showClearButton: 'true',    onValueChanged: poslovnicaPrijemaChange, width: '400px', readOnly: samoPregled || status === 'z'}">
                </dxi-item>             <!-- searchExpr: ['po_naziv', 'po_sifra'], -->
            </dxi-item>

        </dx-form>
        <!-- <div *ngIf="statusUFA == 'z'">
<p>Popis primki:</p>
<ul>
    <li *ngFor="let primka of skladiste_primka">
        {{ primka }}
    </li>
</ul>
</div> -->

        <div class="btnsUFA" *ngIf="statusUFA != 'z'">
            <dx-button #myButton stylingMode="text" type="default" text="Spremi" (onClick)="spremiUFA(ulaznafaktura)" [disabled]="saveButtonDisabled"></dx-button>
            <dx-button stylingMode="text" type="default" class="cancel" id="button" [useSubmitBehavior]="true"
                text="Odustani" (onClick)="odustaniUFA()"></dx-button>
        </div>

        <div class="btnsUFA" *ngIf="statusUFA == 'z'">
            <dx-button #myButton stylingMode="text" type="default" text="Omogući izmjene" (onClick)="omoguciIzmjene()"></dx-button>
        </div>

        <div class="btnsUFA" *ngIf="statusUFA == 'z' && omoguciZavrseneIzmjene">
            <dx-button #myButton stylingMode="text" type="default" text="Spremi" (onClick)="spremiUFA(ulaznafaktura)"></dx-button>
            <dx-button stylingMode="text" type="default" class="cancel" id="button" [useSubmitBehavior]="true"
                text="Odustani" (onClick)="odustaniUFA()"></dx-button>
        </div>
    </div>
    <!----------------- PRIMKE POPIS ODABIR ----------------------->
    <div class="popisprimke" *ngIf="UFASpremljena && statusUFA != 'z'">
        <p>Primke</p>
        <dx-drop-down-box #dropdown 
            (onOpened)="onOpened($event)" 
            [readOnly]="samoPregled"
            [(value)]="primkePrikazDropDown" 
            width="85%" 
            valueExpr="pz_id" 
            displayExpr="broj_primke"
            [dataSource]="primke">
            <dxo-drop-down-options>
                <dxi-toolbar-item toolbar="bottom" widget="dxButton" location="after" [options]="{
                    text: 'Spremi',
                    onClick: spremiDropdown                        
                }">
                </dxi-toolbar-item>
                <dxi-toolbar-item toolbar="bottom" widget="dxButton" location="after" [options]="{
                    text: 'Odustani',
                    onClick: closeDropDown                      
                }">
                </dxi-toolbar-item>
            </dxo-drop-down-options>
            <div *dxTemplate="let data of 'content'">
                <dx-scroll-view height="100%" width="100%" class="with-footer single-card">
                    <dx-data-grid 
                        #primkeTablica 
                        [dataSource]="primke"
                        [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always' }" 
                        [recursive]="true"
                        selectAllMode="allPages" 
                        [showColumnLines]="true" 
                        [hoverStateEnabled]="true"
                        [paging]="{ enabled: true, pageSize: 10 }" 
                        [scrolling]="{ mode: 'virtual' }" 
                        [height]="300"
                        keyExpr="pz_id" 
                        (onRowExpanding)="onExpanding($event)"
                        (onSelectionChanged)="onSelectionChanged($event)" 
                        [(selectedRowKeys)]="odabranePrimke">
                        <dxo-filter-row [visible]="true"></dxo-filter-row>

                        <dxi-column dataField="pa_naziv" caption="Tvrtka"></dxi-column>
                        <dxi-column dataField="skladiste_primka" caption="Broj dokumenta" alignment="left"></dxi-column>
                        <dxi-column dataField="pz_datum" caption="Datum primke" dataType="date" alignment="center" [allowFiltering]="false"></dxi-column>
                        <dxi-column dataField="pz_dokumpar" caption="Dokument partnera"></dxi-column>
                        <dxi-column dataField="pz_iznos" caption="Iznos" [editorOptions]="{ format: { type: 'fixedPoint',  precision: 2 } }" [allowSearching]="true">
                            <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
                        </dxi-column>

                        <!------ PODTABLICA ------->
                        <dxo-master-detail [enabled]="true" [template]="'stavkePrimke'"></dxo-master-detail>
                        <div *dxTemplate="let stavka of 'stavkePrimke'">
                            <div class="master-detail-caption caption">STAVKE PRIMKE</div>
                            <div class="internal-grid-container">
                                <dx-data-grid #target class="stavke" [dataSource]="stavkePodtablica"
                                    [showColumnLines]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
                                    [columnMinWidth]="100">
                                    <dxi-column caption="#" cellTemplate="rb" width="50" alignment="center">
                                        <div *dxTemplate="let data of 'rb'">
                                            <div> {{ data.component.pageIndex() * data.component.pageSize() +
                                                data.rowIndex+1 }}. </div>
                                        </div>
                                    </dxi-column>
                                    <dxi-column dataField="ar_sifra" caption="Šifra"></dxi-column>
                                    <dxi-column dataField="ar_naziv" caption="Naziv"></dxi-column>
                                    <dxi-column dataField="ps_ulaz" caption="Količina" alignment="center"></dxi-column>
                                    <dxi-column dataField="jedinicamjere_JM_SIFRA" caption="Jmj"></dxi-column>
                                    <dxi-column dataField="ps_brutocij" caption="Cijena"
                                        [format]="{ type: 'fixedPoint', precision: 5 }" alignment="right"></dxi-column>
                                    <dxi-column dataField="ps_postorabata" caption="Rabat (%)"
                                        alignment="center"></dxi-column>
                                    <dxi-column [allowEditing]="false" dataField="neto_iznos" caption="Neto iznos"
                                        [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right"></dxi-column>
                                    <dxi-column dataField="pz_posto" caption="PDV (%)"
                                        [format]="{ type: 'fixedPoint', precision: 2 }" alignment="center"></dxi-column>
                                    <dxi-column [allowEditing]="false" dataField="porez_iznos" caption="PDV iznos"
                                        [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right"></dxi-column>
                                </dx-data-grid>
                            </div>
                        </div>
                    </dx-data-grid>
                </dx-scroll-view>
            </div>
        </dx-drop-down-box>
    </div>

    <!----------------------- STAVKE ULAZNE FAKTURE ------------------------->
    <div class="content-block" *ngIf="postojeStavke">
        <dx-data-grid 
            [rowAlternationEnabled]="true" 
            [hoverStateEnabled]="true" 
            class="dx-card wide-card"
            [wordWrapEnabled]="true" 
            [dataSource]="stavkeUFE" 
            [showColumnLines]="true" 
            [showBorders]="true"
            [showRowLines]="true" 
            keyExpr="ps_id" 
            [focusedRowEnabled]="true" 
            [autoNavigateToFocusedRow]="false"
            (onEditorPreparing)="onEditorPreparing($event)" 
            (onToolbarPreparing)="onToolbarPreparing($event)">

            <dxo-editing [allowUpdating]="statusUFA == 'n'" mode="batch"></dxo-editing>

            <dxo-search-panel [visible]="true" placeholder="Pretraži..."></dxo-search-panel>
            <dxo-paging [pageSize]="30"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[30, 60, 90]" [showInfo]="true" [visible]="true"></dxo-pager>

            <dxi-column dataField="rb" caption="#" width="50" [formItem]="{ visible: false }" alignment="right" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="ar_sifra" caption="Šifra" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="ar_naziv" caption="Naziv" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="ps_ulaz" caption="Količina" alignment="center" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="jedinicamjere_JM_SIFRA" caption="Jmj" alignment="center"
            [allowEditing]="false"></dxi-column>
            <!-- <dxi-column dataField="ps_povnak" caption="Pov. naknada" [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right" [allowEditing]="false"></dxi-column> -->
            
            <dxi-column dataField="ps_brutocij" caption="Bruto cijena" alignment="right" [allowEditing]="false" [format]="{ type: 'fixedPoint', precision: 5 }"></dxi-column>
            <dxi-column dataField="ps_ulazc" caption="Neto cijena" [format]="{ type: 'fixedPoint', precision: 5 }"
                alignment="right" [allowEditing]="true"
                [editorOptions]="{onValueChanged: onCijenaValueChanged }"></dxi-column>
            <dxi-column dataField="ps_postorabata" caption="Rabat (%)" alignment="center"
                [allowEditing]="false"></dxi-column>
            <dxi-column [allowEditing]="true" dataField="bruto_iznos" caption="Bruto iznos" [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right" [allowEditing]="false"></dxi-column>
            <dxi-column [allowEditing]="true" dataField="neto_iznos" caption="Neto iznos"
                [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right" [editorOptions]="{onValueChanged: onIznosValueChanged }"></dxi-column>
            <dxi-column dataField="pz_posto" caption="PDV (%)" [format]="{ type: 'fixedPoint', precision: 2 }"
                alignment="center" [allowEditing]="true" [editorOptions]="{onValueChanged: onPorezValueChanged }"></dxi-column>
            <dxi-column [allowEditing]="false" dataField="porez_iznos" caption="PDV iznos"
                [format]="{ type: 'fixedPoint', precision: 2 }" alignment="right"></dxi-column>

            <div *dxTemplate="let data of 'naslovTablice'">
                <div class="naslov" style="margin-right: 10px;">
                    <p class="name">Stavke dokumenta</p>
                </div>
            </div>

            <div *dxTemplate="let data of 'ispis'">
                <dx-button *ngIf="stavkeUFE.length > 0" icon="exportpdf" class="ispis" text="ISPIS UFE" type="default"
                    (onClick)="ispisUFE(brojdok)" style="margin-right: 10px;"></dx-button>
                <dx-button *ngIf="(stavkeUFE.length > 0 && statusUFA != 'z')" type="danger" text="zaključi UFU"
                    class="zakljuci" (onClick)="infoKonacnoSpremanje()"></dx-button>
            </div>

            <dxo-summary [calculateCustomSummary]="calculateSummary" *ngIf="stavkeUFE.length > 0">
                <dxi-total-item showInColumn="pz_posto" alignment="left" displayFormat="UKUPNO: "></dxi-total-item>
                <dxi-total-item showInColumn="porez_iznos" summaryType='custom' name="ukupno" alignment="right"
                    displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
                <dxi-total-item showInColumn="pz_posto" alignment="left"
                    displayFormat="IZNOS RABATA: "></dxi-total-item>
                <dxi-total-item showInColumn="porez_iznos" summaryType='custom' name="iznosPopusta" alignment="right"
                    displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
                <dxi-total-item showInColumn="pz_posto" alignment="left" displayFormat="OSNOVICA: "></dxi-total-item>
                <dxi-total-item showInColumn="porez_iznos" column="neto_iznos" summaryType='sum' alignment="right"
                    displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
                <dxi-total-item showInColumn="pz_posto" alignment="left" displayFormat="PDV: "></dxi-total-item>
                <dxi-total-item showInColumn="porez_iznos" column="porez_iznos" summaryType='sum' name="iznosPDV"
                    alignment="right" displayFormat="{0}"
                    [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>

                <dxi-total-item *ngIf="!eurikn" showInColumn="pz_posto" alignment="left"
                    displayFormat="IZNOS KN: "></dxi-total-item>
                <dxi-total-item *ngIf="eurikn" showInColumn="pz_posto" alignment="left"
                    displayFormat="IZNOS €: "></dxi-total-item>
                <dxi-total-item showInColumn="porez_iznos" summaryType='custom' name="iznoskn" alignment="right"
                    cssClass="iznos" displayFormat="{0}"
                    [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>